const API_URL = "https://tesorobyconcert.com/wordpress/wp-json/acf/v3";

const apiUrl = path => `${API_URL}${path}`;

export { API_URL, apiUrl }